/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { ROLES } from '../../../constants';
import { selectCurrentEmpid, selectCurrentUserManagerLevel, selectIsPseudoSupervisor } from '../../../pages/login/authSlice';
import { getRole } from '../../../utils/roleUtils';
import { EmployeeSearchPopUp } from '../employeeSearchPopUp/EmployeeSearchPopUp';
import { RevgenFilter } from './RevgenFilters';
import { RevgenGrid } from './RevgenGrid';
import { useGetRevGenCoachingGoalQuery } from './revGenSlice';
import './revgen.scss';
import { RevgenProps, SearchedEmployeType } from './type';
import { saveSCfilDate } from '../../../utils/dateStorage';

export const Revgen = ({ inputMonth, inputYear, date, setMonth, setYear, setDate, teamOptionId, entityId, entityDate }: RevgenProps) => {
    const userManagerLevel = useSelector(selectCurrentUserManagerLevel);
    const isPseudoSupervisor=useSelector(selectIsPseudoSupervisor);
    const loggedEmpNum = useSelector(selectCurrentEmpid);
    const [selectedTeam, setSelectedTeam] = useState<string>();
    const [selectTeamList, setSelectTeamList] = useState<string[]>();
    const [visible, setVisible] = useState<boolean>(false);
    const [revgenList, setRevgenList] = useState<string[]>([]);
    const [selectedEmployee, setSelectedEmployee] = useState<string>(); //use this state for api call
    const [goalAuthor, setGoalAuthor] = useState<string>('');
    const [goalYear, setGoalYear] = useState<number>(0);
    const [goalMonth, setGoalMonth] = useState<number>(0);
    const [goalRecipient, setGoalRecipient] = useState<string>('');
    
    const [searchedEmployee, setSearchedEmployee] = useState<SearchedEmployeType>({
        employee_name: '',
        employee_number: '',
        location: '',
        job_title: '',
    });
    const { data: mygoals } = useGetRevGenCoachingGoalQuery(
        {
            authorId: goalAuthor || loggedEmpNum,
            recipientId: selectedTeam === 'search' ? selectedEmployee : loggedEmpNum,
            year: goalYear || inputYear,
            month: goalMonth || inputMonth,
            teamOption: selectedTeam === 'myActivity' ? 'mygoals' : 'myteamgoals',
            role: getRole(userManagerLevel,isPseudoSupervisor),
        },
        {
            skip:
                !loggedEmpNum ||
                !inputYear ||
                !inputMonth ||
                !selectedTeam ||
                (selectedTeam === 'search' && !selectedEmployee),
        }
    );
    useEffect(() => {
        if (teamOptionId && entityId && entityDate) {
            const goalDetails = entityId?.split('-');
            if (goalDetails.length === 4) {
                setGoalAuthor(goalDetails[0]);
                setGoalYear(Number(goalDetails[1]));
                setGoalMonth(Number(goalDetails[2]));
                setGoalRecipient(goalDetails[3]);
            }
            setSelectedTeam('myTeamActivity');
        }
    }, [teamOptionId, entityId, entityDate]);
    const DateOnChange = (e: any) => {
        if (!(e.value instanceof Date) || isNaN(e.value.getTime())) return;
        setDate(e.value);
        setMonth(e.value.getMonth() + 1);
        setYear(e.value.getFullYear());
        saveSCfilDate(e.value);
    };
    const handleReset = () => {
        setSelectedTeam('');
        setDate(new Date());
    };

    useEffect(() => {
        setSelectedEmployee(loggedEmpNum);
    }, []);

    useEffect(() => {
        if (mygoals?.data?.length > 0) {
            if (selectedTeam === 'myTeamActivity' && ROLES.Manager.includes(userManagerLevel)) {
                const filterOutOwnRec = mygoals?.data?.filter(
                    (record: any) => record.employee_number !== loggedEmpNum
                );
                setRevgenList(filterOutOwnRec);
            } else {
                setRevgenList(mygoals?.data);
            }
        }        
    }, [mygoals]);

    useEffect(() => {
        const searchedUserString: string | null = localStorage.getItem('searchedUser');
        if (selectedTeam === 'search') {
            if (searchedUserString) {
                const searchedUser: SearchedEmployeType = JSON.parse(searchedUserString);
                setVisible(false);
                setSearchedEmployee(searchedUser);
            } else {
                setVisible(true);
            }
        }
    }, [selectedTeam])

    useEffect(() => {
        setSelectedEmployee(searchedEmployee?.employee_number);
    }, [searchedEmployee]);

    return (
        <>
            <RevgenFilter
                date={date}
                selectTeamList={selectTeamList}
                selectedTeam={selectedTeam}
                userManagerLevel={userManagerLevel}
                handleReset={handleReset}
                DateOnChange={DateOnChange}
                setSelectedTeam={setSelectedTeam}
                setVisible={setVisible}
                setSelectTeamList={setSelectTeamList}
                parent="revgenGoal"
            />
            <RevgenGrid
                selectedTeam={selectedTeam}
                revgenList={revgenList}
                inputMonth={inputMonth}
                inputYear={inputYear}
                goalRecipient={goalRecipient}
            />
            {visible && (
                <EmployeeSearchPopUp
                    visible={visible}
                    searchedEmployee={searchedEmployee}
                    setVisible={setVisible}
                    setSelectedTeam={setSelectedTeam}
                    setSearchedEmployee={setSearchedEmployee}
                />
            )}
        </>
    );
};
